import React from 'react';
import { SkeletonLabel } from '@noths/polaris-client-ribbons-design-system';

import * as styles from '../styles';

export interface DeliveryOptionSkeletonProps {
  isFirstOption: boolean;
}

export const DeliveryOptionSkeleton = ({ isFirstOption }: DeliveryOptionSkeletonProps) => {
  const dateAndPriceStyle = isFirstOption
    ? styles.firstDateAndPriceSkeleton
    : styles.dateAndPriceSkeleton;
  const dateAndPriceHeight = isFirstOption ? 'MD' : 'XS';

  return (
    <div css={[styles.deliveryOptionSkeletonWrapper, styles.deliveryOption]}>
      <SkeletonLabel css={styles.optionTypeSkeleton} labelHeight="XS" />
      <SkeletonLabel css={dateAndPriceStyle} labelHeight={dateAndPriceHeight} />
      <SkeletonLabel css={dateAndPriceStyle} labelHeight={dateAndPriceHeight} />
    </div>
  );
};
